import React, { useState } from "react";
import { Tab } from "react-bootstrap";
import { apiConfig } from "../../../config";
import useAuth from "../../../hooks/useAuth";
import axios from "axios";
import { useSelector } from "react-redux";
import Dot11Admin from "./Dot11Admin";
import AzureRadiusAdmin from "./AzureRadiusAdmin";

const RadiusManagement = () => {
  const { userAccessToken } = useAuth();
  const bearerToken = `Bearer ${userAccessToken}`;
  const selectedLandlord = useSelector((state) => state.landlordswitcher);

  const [customerOptions, setCustomerOptions] = useState([]);
  const [isLoadingCustomerOptions, setIsLoadingCustomerOptions] =
    useState(true);
  React.useEffect(() => {
    const axiosConfig = {
      headers: { Authorization: bearerToken },
    };
    setIsLoadingCustomerOptions(true);
    if (selectedLandlord.landlordid) {
      axios
        .get(
          apiConfig.symbillApiUrl +
            "newsymbillapi/byCtidList/" +
            selectedLandlord.landlordid,
          axiosConfig
        )
        .then(function (response) {
          let customersList = [];
          response.data.forEach((customer) => {
            customersList.push({
              value: customer.accountNumber,
              label: customer.companyName + " (" + customer.accountNumber + ")",
            });
          });
          setCustomerOptions(customersList);
          setIsLoadingCustomerOptions(false);
        })
        .catch(function (error) {
          setIsLoadingCustomerOptions(false);
        });
    } else {
      setCustomerOptions([]);
      setIsLoadingCustomerOptions(false);
    }
  }, [selectedLandlord, bearerToken]);

  return (
    <Tab.Pane eventKey="#RadiusTools">
      <Dot11Admin
        customerOptions={customerOptions}
        isLoadingCustomerOptions={isLoadingCustomerOptions}
      />
      <hr />
      <AzureRadiusAdmin
        customerOptions={customerOptions}
        isLoadingCustomerOptions={isLoadingCustomerOptions}
      />
    </Tab.Pane>
  );
};

export default RadiusManagement;
